/**
 * Every string the billing feature shows, in one place.
 *
 * Somali wherever the phone already says it in Somali, English wherever the
 * phone has no parallel — the house rule. The Somali lines below are copied
 * character for character from the phone so a shopkeeper reads the same
 * sentence on both screens:
 *
 *   title          modal_payment.dart:169
 *   phoneLabel     modal_payment.dart:488
 *   phoneHint      modal_payment.dart:493
 *   payNow         modal_payment.dart:392
 *   checkPhone     modal_payment.dart:562
 *   checkPhoneSub  modal_payment.dart:567
 *   paidTitle      modal_success.dart
 *   paidSub        modal_success.dart
 *   phoneRequired  payment_cubit.dart:27
 *
 * The decline messages are NOT here. They are written by the server, in
 * Somali, and shown exactly as they arrive — there is no second copy of them
 * on this side to drift out of step.
 */
export const COPY = {
  /* ── the strip in the app bar ──────────────────────────────────────── */

  // Verbatim, as given. Not edited.
  banner: 'Macaamiil, waxaa kugu taagan lacagta billaha. Faldan iska bixi. Mahadsanid.',
  bannerAction: 'BIXI',
  hideBanner: 'Hide this',

  /* ── the dialog ────────────────────────────────────────────────────── */

  title: 'Lacag Bixinta Billaha',
  monthsChip: (months) => `${months} BIL`,
  total: 'total',
  nextBill: 'Next bill',
  loadingPlans: 'Loading plans…',

  phoneLabel: 'Geli Number',
  phoneHint: 'Number-ka aad lacagta ka dirayso',
  phonePlaceholder: '61 000 0000',
  countryCode: '+252',
  payNow: 'HADDA BIXI',

  /**
   * A locked till still has to be able to change hands — a manager who cannot
   * pay right now must be able to hand the screen to a waiter. This is the
   * only other door out of the `stuck` dialog.
   */
  signOut: 'Logout',

  /* ── in flight ─────────────────────────────────────────────────────── */

  checkPhone: 'Fiiri Teleefankaaga!',
  checkPhoneSub: 'Taabo Hal, kidibna geli Pin-kaaga si aad u dirto lacagta',
  keepOpen: 'Keep this window open until it finishes',

  /* ── it worked ─────────────────────────────────────────────────────── */

  paidTitle: 'Successfully Paid',
  paidSub: (months, date) =>
    `Waxaa isku bixisay ${months} bilood. Lacag bixinta xigta waa ${date}`,
  receiptPlan: 'Plan',
  receiptFrom: 'From',
  receiptPaid: 'Paid',
  ok: 'Ok',

  /* ── it did not ────────────────────────────────────────────────────── */

  declinedTitle: 'Lama bixin',
  gatewayTitle: 'Isku day mar kale',
  retry: 'Isku day mar kale',
  cancel: 'Cancel',

  /**
   * The one screen the phone does not have.
   *
   * The charge is a single blocking request and there is no webhook, no status
   * endpoint and no idempotency key on the server — so when the connection
   * dies mid-charge, nothing anywhere knows whether the money moved, and a
   * retry can take it twice. This says so plainly and makes the safe choice
   * the loud one.
   */
  unsureTitle: "We couldn't confirm this",
  unsureBody:
    'The connection dropped before we heard back. Check the phone for a Waafi message before paying again — trying twice can charge twice.',
  unsureClose: 'Close & check the phone',
  unsureRetry: 'Pay again anyway',

  /* ── refusals this side of the wire ────────────────────────────────── */

  phoneRequired: 'Fadlan Geli Mobile-ka aad lacagta ka diraysid',
  phoneTooShort: 'Fadlan Geli Mobile-ka aad lacagta ka diraysid',
  noPlan: 'No payment plan is available. Please contact Dalabtire.',
  plansFailed: "Couldn't load the payment plans.",
  tryAgain: 'Try again',

  /** Only used if the server declines without saying why. */
  genericDecline: 'Waan ka xunnahay, laguma guuleysan adeegaan.',
  /** Only used if the server fails without saying why. */
  genericGateway: 'Lacag bixinta lama gaari karo hadda. Fadlan mar kale isku day.',
};
